import React from "react";
import Select from "react-select";
import { OPTION_LABELS } from "../../../config/lang";
import { translate } from "../../../util/util";

export default function SelectField({ field, value, onChange, lang }) {
  // Localize option display labels (keyed by value); fall back to the raw label.
  const opts = (field.options || []).map(o => ({ ...o, label: translate(OPTION_LABELS, String(o.value), lang) || o.label }));
  const selected = opts.find(o => o.value === value) || null;
  return (
    <div className="mp-form-group">
      <label className="mp-form-label">{field._label}{field.required && " *"}</label>
      <Select
        className="mp-select"
        options={opts}
        value={selected}
        isClearable={!field.required}
        onChange={o => onChange(field.name, o ? o.value : null)}
      />
    </div>
  );
}
